import {
    CalendarDateFormatter,
    DateFormatterParams,
} from '@gallaghercp/core-calendar';
import { formatDate } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable()
export class CustomDateFormatter extends CalendarDateFormatter {
    // you can override any of the methods defined in the parent class

    public override monthViewColumnHeader({
        date,
        locale,
    }: DateFormatterParams): string {
        return formatDate(date, 'EEE', locale as string);
    }

    public override monthViewTitle({
        date,
        locale,
    }: DateFormatterParams): string {
        return formatDate(date, 'MMM y', locale as string);
    }

    public override weekViewColumnHeader({
        date,
        locale,
    }: DateFormatterParams): string {
        return formatDate(date, 'EEE', locale as string);
    }

    public override dayViewHour({ date, locale }: DateFormatterParams): string {
        return formatDate(date, 'HH:mm', locale as string);
    }
}
